export const Code = {
  Afghanistan: 'AF',
  Aland_Islands: 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antigua_and_Barbuda: 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  Bosnia_and_Herzegovina: 'BA',
  Botswana: 'BW',
  Brazil: 'BR',
  Brunei: 'BN',
  Bulgaria: 'BG',
  Burkina_Faso: 'BF',
  Burundi: 'BI',
  Cabo_Verde: 'CV',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  Cayman_Islands: 'KY',
  Central_African_Republic: 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  Colombia: 'CO',
  Comoros: 'KM',
  Congo_Democratic_Republic: 'CD',
  Congo_Republic: 'CG',
  Costa_Rica: 'CR',
  Cote_d_Ivoire: 'CI',
  Croatia: 'HR',
  Cuba: 'CU',
  Cyprus: 'CY',
  Czechia: 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  Dominican_Republic: 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  El_Salvador: 'SV',
  Equatorial_Guinea: 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Eswatini: 'SZ',
  Ethiopia: 'ET',
  Falkland_Islands: 'FK',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  French_Polynesia: 'PF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Grenada: 'GD',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea_Bissau: 'GW',
  Guinea: 'GN',
  Guyana: 'GY',
  Haiti: 'HT',
  Honduras: 'HN',
  Hong_Kong: 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Iran: 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  Isle_of_Man: 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Korea_North: 'KP',
  Korea_South: 'KR',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  Lao_Peoples_Democratic_Republic: 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mexico: 'MX',
  Micronesia: 'FM',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nepal: 'NP',
  Netherlands_Antilles: 'AN',
  Netherlands: 'NL',
  New_Zealand: 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  North_Macedonia: 'MK',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  Panama: 'PA',
  Papua_New_Guinea: 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Poland: 'PL',
  Portugal: 'PT',
  Puerto_Rico: 'PR',
  Qatar: 'QA',
  Romania: 'RO',
  Russia: 'RU',
  Rwanda: 'RW',
  Saint_Helena: 'SH',
  Saint_Kitts_and_Nevis: 'KN',
  Saint_Lucia: 'LC',
  Saint_Vincent_and_the_Grenadines: 'VC',
  Samoa: 'WS',
  San_Marino: 'SM',
  Sao_Tome_and_Principe: 'ST',
  Saudi_Arabia: 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  Sierra_Leone: 'SL',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  Solomon_Islands: 'SB',
  Somalia: 'SO',
  South_Africa: 'ZA',
  Spain: 'ES',
  Sri_Lanka: 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  Sweden: 'SE',
  Switzerland: 'CH',
  Syria: 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Thailand: 'TH',
  Timor_Leste: 'TL',
  Togo: 'TG',
  Tonga: 'TO',
  Trinidad_and_Tobago: 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  Turks_and_Caicos_Islands: 'TC',
  Uganda: 'UG',
  Ukraine: 'UA',
  United_Arab_Emirates: 'AE',
  /** @internal UK alias for DB compatibility - maps to GB (ISO standard) */
  United_Kingdom_UK_Alias: 'UK',
  United_Kingdom: 'GB',
  United_States: 'US',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  Venezuela: 'VE',
  Vietnam: 'VN',
  Virgin_Islands_British: 'VG',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
} as const;

export type Code = (typeof Code)[keyof typeof Code];
export type CountryName = keyof typeof Code;

/**
 * Will need to understand the need to get alternative locales for
 * countries like Belgium or Switzerland that have multiple official languages.
 */
export const Locale = {
  Afghanistan: 'ps-AF',
  Aland_Islands: 'sv-AX',
  Albania: 'sq-AL',
  Algeria: 'ar-DZ',
  Andorra: 'ca-AD',
  Angola: 'pt-AO',
  Anguilla: 'en-AI',
  Antigua_and_Barbuda: 'en-AG',
  Argentina: 'es-AR',
  Armenia: 'hy-AM',
  Aruba: 'nl-AW',
  Australia: 'en-AU',
  Austria: 'de-AT',
  Azerbaijan: 'az-AZ',
  Bahamas: 'en-BS',
  Bahrain: 'ar-BH',
  Bangladesh: 'bn-BD',
  Barbados: 'en-BB',
  Belarus: 'be-BY',
  Belgium: 'nl-BE', // also fr-BE, de-BE in some regions
  Belize: 'en-BZ',
  Benin: 'fr-BJ',
  Bermuda: 'en-BM',
  Bhutan: 'dz-BT',
  Bolivia: 'es-BO',
  Bosnia_and_Herzegovina: 'bs-BA',
  Botswana: 'en-BW',
  Brazil: 'pt-BR',
  Brunei: 'ms-BN',
  Bulgaria: 'bg-BG',
  Burkina_Faso: 'fr-BF',
  Burundi: 'fr-BI',
  Cabo_Verde: 'pt-CV',
  Cambodia: 'km-KH',
  Cameroon: 'fr-CM',
  Canada: 'en-CA', // also fr-CA
  Cayman_Islands: 'en-KY',
  Central_African_Republic: 'fr-CF',
  Chad: 'fr-TD',
  Chile: 'es-CL',
  China: 'zh-CN',
  Colombia: 'es-CO',
  Comoros: 'fr-KM',
  Congo_Democratic_Republic: 'fr-CD',
  Congo_Republic: 'fr-CG',
  Costa_Rica: 'es-CR',
  Cote_d_Ivoire: 'fr-CI',
  Croatia: 'hr-HR',
  Cuba: 'es-CU',
  Cyprus: 'el-CY',
  Czechia: 'cs-CZ',
  Denmark: 'da-DK',
  Djibouti: 'ar-DJ',
  Dominica: 'en-DM',
  Dominican_Republic: 'es-DO',
  Ecuador: 'es-EC',
  Egypt: 'ar-EG',
  El_Salvador: 'es-SV',
  Equatorial_Guinea: 'es-GQ',
  Eritrea: 'ti-ER',
  Estonia: 'et-EE',
  Eswatini: 'ss-SZ',
  Ethiopia: 'am-ET',
  Falkland_Islands: 'en-FK',
  Fiji: 'en-FJ',
  Finland: 'fi-FI',
  France: 'fr-FR',
  French_Polynesia: 'fr-PF',
  Gabon: 'fr-GA',
  Gambia: 'en-GM',
  Georgia: 'ka-GE',
  Germany: 'de-DE',
  Ghana: 'en-GH',
  Gibraltar: 'en-GI',
  Greece: 'el-GR',
  Grenada: 'en-GD',
  Guatemala: 'es-GT',
  Guernsey: 'en-GG',
  Guinea_Bissau: 'pt-GW',
  Guinea: 'fr-GN',
  Guyana: 'en-GY',
  Haiti: 'ht-HT',
  Honduras: 'es-HN',
  Hong_Kong: 'zh-HK', // also en-HK
  Hungary: 'hu-HU',
  Iceland: 'is-IS',
  India: 'hi-IN', // also en-IN
  Indonesia: 'id-ID',
  Iran: 'fa-IR',
  Iraq: 'ar-IQ',
  Ireland: 'en-IE', // also ga-IE
  Isle_of_Man: 'en-IM',
  Israel: 'he-IL',
  Italy: 'it-IT',
  Jamaica: 'en-JM',
  Japan: 'ja-JP',
  Jersey: 'en-JE',
  Jordan: 'ar-JO',
  Kazakhstan: 'kk-KZ',
  Kenya: 'en-KE',
  Korea_North: 'ko-KP',
  Korea_South: 'ko-KR',
  Kuwait: 'ar-KW',
  Kyrgyzstan: 'ky-KG',
  Lao_Peoples_Democratic_Republic: 'lo-LA',
  Latvia: 'lv-LV',
  Lebanon: 'ar-LB',
  Lesotho: 'st-LS',
  Liberia: 'en-LR',
  Libya: 'ar-LY',
  Liechtenstein: 'de-LI',
  Lithuania: 'lt-LT',
  Luxembourg: 'lb-LU',
  Macao: 'zh-MO',
  Madagascar: 'mg-MG',
  Malawi: 'ny-MW',
  Malaysia: 'ms-MY',
  Maldives: 'dv-MV',
  Mali: 'fr-ML',
  Malta: 'mt-MT',
  Mauritania: 'ar-MR',
  Mauritius: 'fr-MU',
  Mexico: 'es-MX',
  Micronesia: 'en-FM',
  Moldova: 'ro-MD',
  Monaco: 'fr-MC',
  Mongolia: 'mn-MN',
  Montenegro: 'sr-ME',
  Montserrat: 'en-MS',
  Morocco: 'ar-MA',
  Mozambique: 'pt-MZ',
  Myanmar: 'my-MM',
  Namibia: 'en-NA',
  Nepal: 'ne-NP',
  Netherlands_Antilles: 'nl-AN',
  Netherlands: 'nl-NL',
  New_Zealand: 'en-NZ',
  Nicaragua: 'es-NI',
  Niger: 'fr-NE',
  Nigeria: 'en-NG',
  North_Macedonia: 'mk-MK',
  Norway: 'nb-NO',
  Oman: 'ar-OM',
  Pakistan: 'ur-PK',
  Palau: 'en-PW',
  Panama: 'es-PA',
  Papua_New_Guinea: 'en-PG',
  Paraguay: 'es-PY',
  Peru: 'es-PE',
  Philippines: 'en-PH', // also fil-PH
  Poland: 'pl-PL',
  Portugal: 'pt-PT',
  Puerto_Rico: 'es-PR',
  Qatar: 'ar-QA',
  Romania: 'ro-RO',
  Russia: 'ru-RU',
  Rwanda: 'rw-RW',
  Saint_Helena: 'en-SH',
  Saint_Kitts_and_Nevis: 'en-KN',
  Saint_Lucia: 'en-LC',
  Saint_Vincent_and_the_Grenadines: 'en-VC',
  Samoa: 'sm-WS',
  San_Marino: 'it-SM',
  Sao_Tome_and_Principe: 'pt-ST',
  Saudi_Arabia: 'ar-SA',
  Senegal: 'fr-SN',
  Serbia: 'sr-RS',
  Seychelles: 'fr-SC',
  Sierra_Leone: 'en-SL',
  Singapore: 'en-SG',
  Slovakia: 'sk-SK',
  Slovenia: 'sl-SI',
  Solomon_Islands: 'en-SB',
  Somalia: 'so-SO',
  South_Africa: 'en-ZA', // also af-ZA, zu-ZA, etc.
  Spain: 'es-ES',
  Sri_Lanka: 'si-LK', // also ta-LK
  Sudan: 'ar-SD',
  Suriname: 'nl-SR',
  Sweden: 'sv-SE',
  Switzerland: 'de-CH', // also fr-CH, it-CH, rm-CH
  Syria: 'ar-SY',
  Taiwan: 'zh-TW',
  Tajikistan: 'tg-TJ',
  Tanzania: 'sw-TZ',
  Thailand: 'th-TH',
  Timor_Leste: 'pt-TL',
  Togo: 'fr-TG',
  Tonga: 'to-TO',
  Trinidad_and_Tobago: 'en-TT',
  Tunisia: 'ar-TN',
  Turkey: 'tr-TR',
  Turkmenistan: 'tk-TM',
  Turks_and_Caicos_Islands: 'en-TC',
  Uganda: 'en-UG',
  Ukraine: 'uk-UA',
  United_Arab_Emirates: 'ar-AE',
  United_Kingdom_UK_Alias: 'en-GB',
  United_Kingdom: 'en-GB',
  United_States: 'en-US',
  Uruguay: 'es-UY',
  Uzbekistan: 'uz-UZ',
  Vanuatu: 'bi-VU',
  Venezuela: 'es-VE',
  Vietnam: 'vi-VN',
  Virgin_Islands_British: 'en-VG',
  Yemen: 'ar-YE',
  Zambia: 'en-ZM',
  Zimbabwe: 'en-ZW',
} as const satisfies Record<CountryName, string>;
export type Locale = (typeof Locale)[keyof typeof Locale];

export const Currency = {
  Afghanistan: 'AFN',
  Aland_Islands: 'EUR',
  Albania: 'ALL',
  Algeria: 'DZD',
  Andorra: 'EUR',
  Angola: 'AOA',
  Anguilla: 'XCD',
  Antigua_and_Barbuda: 'XCD',
  Argentina: 'ARS',
  Armenia: 'AMD',
  Aruba: 'AWG',
  Australia: 'AUD',
  Austria: 'EUR',
  Azerbaijan: 'AZN',
  Bahamas: 'BSD',
  Bahrain: 'BHD',
  Bangladesh: 'BDT',
  Barbados: 'BBD',
  Belarus: 'BYN',
  Belgium: 'EUR',
  Belize: 'BZD',
  Benin: 'XOF',
  Bermuda: 'BMD',
  Bhutan: 'BTN',
  Bolivia: 'BOB',
  Bosnia_and_Herzegovina: 'BAM',
  Botswana: 'BWP',
  Brazil: 'BRL',
  Brunei: 'BND',
  Bulgaria: 'BGN',
  Burkina_Faso: 'XOF',
  Burundi: 'BIF',
  Cabo_Verde: 'CVE',
  Cambodia: 'KHR',
  Cameroon: 'XAF',
  Canada: 'CAD',
  Cayman_Islands: 'KYD',
  Central_African_Republic: 'XAF',
  Chad: 'XAF',
  Chile: 'CLP',
  China: 'CNY',
  Colombia: 'COP',
  Comoros: 'KMF',
  Congo_Democratic_Republic: 'CDF',
  Congo_Republic: 'XAF',
  Costa_Rica: 'CRC',
  Cote_d_Ivoire: 'XOF',
  Croatia: 'EUR',
  Cuba: 'CUP',
  Cyprus: 'EUR',
  Czechia: 'CZK',
  Denmark: 'DKK',
  Djibouti: 'DJF',
  Dominica: 'XCD',
  Dominican_Republic: 'DOP',
  Ecuador: 'USD',
  Egypt: 'EGP',
  El_Salvador: 'USD',
  Equatorial_Guinea: 'XAF',
  Eritrea: 'ERN',
  Estonia: 'EUR',
  Eswatini: 'SZL',
  Ethiopia: 'ETB',
  Falkland_Islands: 'FKP',
  Fiji: 'FJD',
  Finland: 'EUR',
  France: 'EUR',
  French_Polynesia: 'XPF',
  Gabon: 'XAF',
  Gambia: 'GMD',
  Georgia: 'GEL',
  Germany: 'EUR',
  Ghana: 'GHS',
  Gibraltar: 'GIP',
  Greece: 'EUR',
  Grenada: 'XCD',
  Guatemala: 'GTQ',
  Guernsey: 'GBP',
  Guinea_Bissau: 'XOF',
  Guinea: 'GNF',
  Guyana: 'GYD',
  Haiti: 'HTG',
  Honduras: 'HNL',
  Hong_Kong: 'HKD',
  Hungary: 'HUF',
  Iceland: 'ISK',
  India: 'INR',
  Indonesia: 'IDR',
  Iran: 'IRR',
  Iraq: 'IQD',
  Ireland: 'EUR',
  Isle_of_Man: 'GBP',
  Israel: 'ILS',
  Italy: 'EUR',
  Jamaica: 'JMD',
  Japan: 'JPY',
  Jersey: 'GBP',
  Jordan: 'JOD',
  Kazakhstan: 'KZT',
  Kenya: 'KES',
  Korea_North: 'KPW',
  Korea_South: 'KRW',
  Kuwait: 'KWD',
  Kyrgyzstan: 'KGS',
  Lao_Peoples_Democratic_Republic: 'LAK',
  Latvia: 'EUR',
  Lebanon: 'LBP',
  Lesotho: 'LSL',
  Liberia: 'LRD',
  Libya: 'LYD',
  Liechtenstein: 'CHF',
  Lithuania: 'EUR',
  Luxembourg: 'EUR',
  Macao: 'MOP',
  Madagascar: 'MGA',
  Malawi: 'MWK',
  Malaysia: 'MYR',
  Maldives: 'MVR',
  Mali: 'XOF',
  Malta: 'EUR',
  Mauritania: 'MRU',
  Mauritius: 'MUR',
  Mexico: 'MXN',
  Micronesia: 'USD',
  Moldova: 'MDL',
  Monaco: 'EUR',
  Mongolia: 'MNT',
  Montenegro: 'EUR',
  Montserrat: 'XCD',
  Morocco: 'MAD',
  Mozambique: 'MZN',
  Myanmar: 'MMK',
  Namibia: 'NAD',
  Nepal: 'NPR',
  Netherlands_Antilles: 'ANG',
  Netherlands: 'EUR',
  New_Zealand: 'NZD',
  Nicaragua: 'NIO',
  Niger: 'XOF',
  Nigeria: 'NGN',
  North_Macedonia: 'MKD',
  Norway: 'NOK',
  Oman: 'OMR',
  Pakistan: 'PKR',
  Palau: 'USD',
  Panama: 'PAB',
  Papua_New_Guinea: 'PGK',
  Paraguay: 'PYG',
  Peru: 'PEN',
  Philippines: 'PHP',
  Poland: 'PLN',
  Portugal: 'EUR',
  Puerto_Rico: 'USD',
  Qatar: 'QAR',
  Romania: 'RON',
  Russia: 'RUB',
  Rwanda: 'RWF',
  Saint_Helena: 'SHP',
  Saint_Kitts_and_Nevis: 'XCD',
  Saint_Lucia: 'XCD',
  Saint_Vincent_and_the_Grenadines: 'XCD',
  Samoa: 'WST',
  San_Marino: 'EUR',
  Sao_Tome_and_Principe: 'STN',
  Saudi_Arabia: 'SAR',
  Senegal: 'XOF',
  Serbia: 'RSD',
  Seychelles: 'SCR',
  Sierra_Leone: 'SLE',
  Singapore: 'SGD',
  Slovakia: 'EUR',
  Slovenia: 'EUR',
  Solomon_Islands: 'SBD',
  Somalia: 'SOS',
  South_Africa: 'ZAR',
  Spain: 'EUR',
  Sri_Lanka: 'LKR',
  Sudan: 'SDG',
  Suriname: 'SRD',
  Sweden: 'SEK',
  Switzerland: 'CHF',
  Syria: 'SYP',
  Taiwan: 'TWD',
  Tajikistan: 'TJS',
  Tanzania: 'TZS',
  Thailand: 'THB',
  Timor_Leste: 'USD',
  Togo: 'XOF',
  Tonga: 'TOP',
  Trinidad_and_Tobago: 'TTD',
  Tunisia: 'TND',
  Turkey: 'TRY',
  Turkmenistan: 'TMT',
  Turks_and_Caicos_Islands: 'USD',
  Uganda: 'UGX',
  Ukraine: 'UAH',
  United_Arab_Emirates: 'AED',
  /** @internal UK alias for DB compatibility */
  United_Kingdom_UK_Alias: 'GBP',
  United_Kingdom: 'GBP',
  United_States: 'USD',
  Uruguay: 'UYU',
  Uzbekistan: 'UZS',
  Vanuatu: 'VUV',
  Venezuela: 'VES',
  Vietnam: 'VND',
  Virgin_Islands_British: 'USD',
  Yemen: 'YER',
  Zambia: 'ZMW',
  Zimbabwe: 'ZWL',
} as const satisfies Record<CountryName, string>;
export type Currency = (typeof Currency)[keyof typeof Currency];

export const CurrencySymbol = {
  Afghanistan: '؋',
  Aland_Islands: '€',
  Albania: 'L',
  Algeria: 'دج',
  Andorra: '€',
  Angola: 'Kz',
  Anguilla: '$',
  Antigua_and_Barbuda: '$',
  Argentina: '$',
  Armenia: '֏',
  Aruba: 'ƒ',
  Australia: '$',
  Austria: '€',
  Azerbaijan: '₼',
  Bahamas: '$',
  Bahrain: '.د.ب',
  Bangladesh: '৳',
  Barbados: '$',
  Belarus: 'Br',
  Belgium: '€',
  Belize: '$',
  Benin: 'CFA',
  Bermuda: '$',
  Bhutan: 'Nu.',
  Bolivia: 'Bs.',
  Bosnia_and_Herzegovina: 'KM',
  Botswana: 'P',
  Brazil: 'R$',
  Brunei: '$',
  Bulgaria: 'лв',
  Burkina_Faso: 'CFA',
  Burundi: 'Fr',
  Cabo_Verde: '$',
  Cambodia: '៛',
  Cameroon: 'CFA',
  Canada: '$',
  Cayman_Islands: '$',
  Central_African_Republic: 'CFA',
  Chad: 'CFA',
  Chile: '$',
  China: '¥',
  Colombia: '$',
  Comoros: 'Fr',
  Congo_Democratic_Republic: 'Fr',
  Congo_Republic: 'CFA',
  Costa_Rica: '₡',
  Cote_d_Ivoire: 'CFA',
  Croatia: '€',
  Cuba: '$',
  Cyprus: '€',
  Czechia: 'Kč',
  Denmark: 'kr',
  Djibouti: 'Fr',
  Dominica: '$',
  Dominican_Republic: '$',
  Ecuador: '$',
  Egypt: '£',
  El_Salvador: '$',
  Equatorial_Guinea: 'CFA',
  Eritrea: 'Nfk',
  Estonia: '€',
  Eswatini: 'L',
  Ethiopia: 'Br',
  Falkland_Islands: '£',
  Fiji: '$',
  Finland: '€',
  France: '€',
  French_Polynesia: 'Fr',
  Gabon: 'CFA',
  Gambia: 'D',
  Georgia: '₾',
  Germany: '€',
  Ghana: '₵',
  Gibraltar: '£',
  Greece: '€',
  Grenada: '$',
  Guatemala: 'Q',
  Guernsey: '£',
  Guinea: 'Fr',
  Guinea_Bissau: 'CFA',
  Guyana: '$',
  Haiti: 'G',
  Honduras: 'L',
  Hong_Kong: 'HK$',
  Hungary: 'Ft',
  Iceland: 'kr',
  India: '₹',
  Indonesia: 'Rp',
  Iran: '﷼',
  Iraq: 'ع.د',
  Ireland: '€',
  Isle_of_Man: '£',
  Israel: '₪',
  Italy: '€',
  Jamaica: '$',
  Japan: '¥',
  Jersey: '£',
  Jordan: 'د.ا',
  Kazakhstan: '₸',
  Kenya: 'Sh',
  Korea_North: '₩',
  Korea_South: '₩',
  Kuwait: 'د.ك',
  Kyrgyzstan: 'сом',
  Lao_Peoples_Democratic_Republic: '₭',
  Latvia: '€',
  Lebanon: 'ل.ل',
  Lesotho: 'L',
  Liberia: '$',
  Libya: 'ل.د',
  Liechtenstein: 'CHF',
  Lithuania: '€',
  Luxembourg: '€',
  Macao: 'P',
  Madagascar: 'Ar',
  Malawi: 'MK',
  Malaysia: 'RM',
  Maldives: 'Rf',
  Mali: 'CFA',
  Malta: '€',
  Mauritania: 'UM',
  Mauritius: '₨',
  Mexico: '$',
  Micronesia: '$',
  Moldova: 'L',
  Monaco: '€',
  Mongolia: '₮',
  Montenegro: '€',
  Montserrat: '$',
  Morocco: 'د.م.',
  Mozambique: 'MT',
  Myanmar: 'K',
  Namibia: '$',
  Nepal: '₨',
  Netherlands: '€',
  Netherlands_Antilles: 'ƒ',
  New_Zealand: '$',
  Nicaragua: 'C$',
  Niger: 'CFA',
  Nigeria: '₦',
  North_Macedonia: 'ден',
  Norway: 'kr',
  Oman: 'ر.ع.',
  Pakistan: '₨',
  Palau: '$',
  Panama: 'B/.',
  Papua_New_Guinea: 'K',
  Paraguay: '₲',
  Peru: 'S/.',
  Philippines: '₱',
  Poland: 'zł',
  Portugal: '€',
  Puerto_Rico: '$',
  Qatar: 'ر.ق',
  Romania: 'lei',
  Russia: '₽',
  Rwanda: 'Fr',
  Saint_Helena: '£',
  Saint_Kitts_and_Nevis: '$',
  Saint_Lucia: '$',
  Saint_Vincent_and_the_Grenadines: '$',
  Samoa: 'T',
  San_Marino: '€',
  Sao_Tome_and_Principe: 'Db',
  Saudi_Arabia: '﷼',
  Senegal: 'CFA',
  Serbia: 'дин',
  Seychelles: '₨',
  Sierra_Leone: 'Le',
  Singapore: '$',
  Slovakia: '€',
  Slovenia: '€',
  Solomon_Islands: '$',
  Somalia: 'Sh',
  South_Africa: 'R',
  Spain: '€',
  Sri_Lanka: '₨',
  Sudan: '£',
  Suriname: '$',
  Sweden: 'kr',
  Switzerland: 'CHF',
  Syria: '£',
  Taiwan: '$',
  Tajikistan: 'ЅМ',
  Tanzania: 'Sh',
  Thailand: '฿',
  Timor_Leste: '$',
  Togo: 'CFA',
  Tonga: 'T$',
  Trinidad_and_Tobago: '$',
  Tunisia: 'د.ت',
  Turkey: '₺',
  Turkmenistan: 'm',
  Turks_and_Caicos_Islands: '$',
  Uganda: 'Sh',
  Ukraine: '₴',
  United_Arab_Emirates: 'د.إ',
  United_Kingdom: '£',
  /** @internal UK alias for DB compatibility */
  United_Kingdom_UK_Alias: '£',
  United_States: '$',
  Uruguay: '$',
  Uzbekistan: 'soʻm',
  Vanuatu: 'Vt',
  Venezuela: 'Bs.',
  Vietnam: '₫',
  Virgin_Islands_British: '$',
  Yemen: '﷼',
  Zambia: 'ZK',
  Zimbabwe: '$',
} as const satisfies Record<CountryName, string>;
export type CurrencySymbol = (typeof CurrencySymbol)[keyof typeof CurrencySymbol];

export const PhoneCode = {
  Afghanistan: '+93',
  Aland_Islands: '+358',
  Albania: '+355',
  Algeria: '+213',
  Andorra: '+376',
  Angola: '+244',
  Anguilla: '+1',
  Antigua_and_Barbuda: '+1',
  Argentina: '+54',
  Armenia: '+374',
  Aruba: '+297',
  Australia: '+61',
  Austria: '+43',
  Azerbaijan: '+994',

  Bahamas: '+1',
  Bahrain: '+973',
  Bangladesh: '+880',
  Barbados: '+1',
  Belarus: '+375',
  Belgium: '+32',
  Belize: '+501',
  Benin: '+229',
  Bermuda: '+1',
  Bhutan: '+975',
  Bolivia: '+591',
  Bosnia_and_Herzegovina: '+387',
  Botswana: '+267',
  Brazil: '+55',
  Brunei: '+673',
  Bulgaria: '+359',
  Burkina_Faso: '+226',
  Burundi: '+257',

  Cabo_Verde: '+238',
  Cambodia: '+855',
  Cameroon: '+237',
  Canada: '+1',
  Cayman_Islands: '+1',
  Central_African_Republic: '+236',
  Chad: '+235',
  Chile: '+56',
  China: '+86',
  Colombia: '+57',
  Comoros: '+269',
  Congo_Democratic_Republic: '+243',
  Congo_Republic: '+242',
  Costa_Rica: '+506',
  Cote_d_Ivoire: '+225',
  Croatia: '+385',
  Cuba: '+53',
  Cyprus: '+357',
  Czechia: '+420',

  Denmark: '+45',
  Djibouti: '+253',
  Dominica: '+1',
  Dominican_Republic: '+1',

  Ecuador: '+593',
  Egypt: '+20',
  El_Salvador: '+503',
  Equatorial_Guinea: '+240',
  Eritrea: '+291',
  Estonia: '+372',
  Eswatini: '+268',
  Ethiopia: '+251',

  Falkland_Islands: '+500',
  Fiji: '+679',
  Finland: '+358',
  France: '+33',
  French_Polynesia: '+689',

  Gabon: '+241',
  Gambia: '+220',
  Georgia: '+995',
  Germany: '+49',
  Ghana: '+233',
  Gibraltar: '+350',
  Greece: '+30',
  Grenada: '+1',
  Guatemala: '+502',
  Guernsey: '+44',
  Guinea: '+224',
  Guinea_Bissau: '+245',
  Guyana: '+592',

  Haiti: '+509',
  Honduras: '+504',
  Hong_Kong: '+852',
  Hungary: '+36',

  Iceland: '+354',
  India: '+91',
  Indonesia: '+62',
  Iran: '+98',
  Iraq: '+964',
  Ireland: '+353',
  Isle_of_Man: '+44',
  Israel: '+972',
  Italy: '+39',

  Jamaica: '+1',
  Japan: '+81',
  Jersey: '+44',
  Jordan: '+962',

  Kazakhstan: '+7',
  Kenya: '+254',
  Korea_North: '+850',
  Korea_South: '+82',
  Kuwait: '+965',
  Kyrgyzstan: '+996',

  Lao_Peoples_Democratic_Republic: '+856',
  Latvia: '+371',
  Lebanon: '+961',
  Lesotho: '+266',
  Liberia: '+231',
  Libya: '+218',
  Liechtenstein: '+423',
  Lithuania: '+370',
  Luxembourg: '+352',

  Macao: '+853',
  Madagascar: '+261',
  Malawi: '+265',
  Malaysia: '+60',
  Maldives: '+960',
  Mali: '+223',
  Malta: '+356',
  Mauritania: '+222',
  Mauritius: '+230',
  Mexico: '+52',
  Micronesia: '+691',
  Moldova: '+373',
  Monaco: '+377',
  Mongolia: '+976',
  Montenegro: '+382',
  Montserrat: '+1',
  Morocco: '+212',
  Mozambique: '+258',
  Myanmar: '+95',

  Namibia: '+264',
  Nepal: '+977',
  Netherlands: '+31',
  Netherlands_Antilles: '+599',
  New_Zealand: '+64',
  Nicaragua: '+505',
  Niger: '+227',
  Nigeria: '+234',
  North_Macedonia: '+389',
  Norway: '+47',

  Oman: '+968',

  Pakistan: '+92',
  Palau: '+680',
  Panama: '+507',
  Papua_New_Guinea: '+675',
  Paraguay: '+595',
  Peru: '+51',
  Philippines: '+63',
  Poland: '+48',
  Portugal: '+351',
  Puerto_Rico: '+1',

  Qatar: '+974',

  Romania: '+40',
  Russia: '+7',
  Rwanda: '+250',

  Saint_Helena: '+290',
  Saint_Kitts_and_Nevis: '+1',
  Saint_Lucia: '+1',
  Saint_Vincent_and_the_Grenadines: '+1',
  Samoa: '+685',
  San_Marino: '+378',
  Sao_Tome_and_Principe: '+239',
  Saudi_Arabia: '+966',
  Senegal: '+221',
  Serbia: '+381',
  Seychelles: '+248',
  Sierra_Leone: '+232',
  Singapore: '+65',
  Slovakia: '+421',
  Slovenia: '+386',
  Solomon_Islands: '+677',
  Somalia: '+252',
  South_Africa: '+27',
  Spain: '+34',
  Sri_Lanka: '+94',
  Sudan: '+249',
  Suriname: '+597',
  Sweden: '+46',
  Switzerland: '+41',
  Syria: '+963',

  Taiwan: '+886',
  Tajikistan: '+992',
  Tanzania: '+255',
  Thailand: '+66',
  Timor_Leste: '+670',
  Togo: '+228',
  Tonga: '+676',
  Trinidad_and_Tobago: '+1',
  Tunisia: '+216',
  Turkey: '+90',
  Turkmenistan: '+993',
  Turks_and_Caicos_Islands: '+1',

  Uganda: '+256',
  Ukraine: '+380',
  United_Arab_Emirates: '+971',
  /** @internal UK alias for DB compatibility */
  United_Kingdom_UK_Alias: '+44',
  United_Kingdom: '+44',
  United_States: '+1',
  Uruguay: '+598',
  Uzbekistan: '+998',

  Vanuatu: '+678',
  Venezuela: '+58',
  Vietnam: '+84',
  Virgin_Islands_British: '+1',

  Yemen: '+967',

  Zambia: '+260',
  Zimbabwe: '+263',
} as const satisfies Record<CountryName, string>;
export type PhoneCode = (typeof PhoneCode)[keyof typeof PhoneCode];

export const PhoneCodeRegionalCode = new Map<Code, readonly string[]>([
  // NANP (+1)
  [Code.Anguilla, ['264']],
  [Code.Antigua_and_Barbuda, ['268']],
  [Code.Bahamas, ['242']],
  [Code.Barbados, ['246']],
  [Code.Bermuda, ['441']],
  [Code.Cayman_Islands, ['345']],
  [Code.Dominica, ['767']],
  [Code.Dominican_Republic, ['809', '829', '849']],
  [Code.Grenada, ['473']],
  [Code.Jamaica, ['876']],
  [Code.Montserrat, ['664']],
  [Code.Puerto_Rico, ['787', '939']],
  [Code.Saint_Kitts_and_Nevis, ['869']],
  [Code.Saint_Lucia, ['758']],
  [Code.Saint_Vincent_and_the_Grenadines, ['784']],
  [Code.Trinidad_and_Tobago, ['868']],
  [Code.Turks_and_Caicos_Islands, ['649']],
  [Code.Virgin_Islands_British, ['284']],

  // UK (+44)
  [Code.Guernsey, ['1481']],
  [Code.Jersey, ['1534']],
  [Code.Isle_of_Man, ['1624']],

  // Finland (+358)
  [Code.Aland_Islands, ['18']],
]);

/**
 * Country information record containing all related data for a country.
 */
export type CountryInfo = {
  name: string;
  code: Code;
  locale: Locale;
  currency: Currency;
  currencySymbol: CurrencySymbol;
  phoneCode: PhoneCode;
  regionalDialingCode: readonly string[];
};
